import React from 'react'

export default function TestingPageComponent() {
  return (
    <div>TestingPageComponent</div>
  )
}
